import React from "react";
import c from "./Header.module.css";

export default function Header({ name }: { name: string }): React.ReactElement {
  return (
    <div className={c.header}>
      <div>{name}</div>
    </div>
  );
}
